#import "../fragments/activity-type-fragment.graphql"

query GetActivityTypes {
    activityTypes {
        ...ActivityType
    }
}
